import { map, first } from 'rxjs/operators';
import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import * as _ from 'lodash';
import { LactationCharacterization, WeaningStatus } from 'src/assets/data/enum/animals.enum';
import { environment } from '../../../environments/environment';
import { Animal } from '../_models/animal';
import { AnimalBreed } from '../_models/animalBreed';
import { MovingAnimals } from '../_models/movingAnimals';

@Injectable()
export class AnimalsService {
  // Services
  private http = inject(HttpClient);
  awsbucket: string = environment.publicAssetsUrl + 'animals/list/';
  imgAnimals = [
    'item1.png',
    'item2.png',
    'item3.png',
    'item4.png',
    'item5.png',
    'item6.png',
    'item7.png',
    'item8.png',
    'item9.png',
  ];
  //TODO in poultryIamges ci sono le immagini per gli avicoli
  poultryImages = ['chicken_meat.png', 'laying_hen.png', 'turkey.png'];
  gendersAnimals = ['male', 'female'];
  states = ['productive', 'sold', 'reformed'];
  animalsList: BehaviorSubject<Array<Animal>> = new BehaviorSubject<Array<Animal>>([]);
  animalBreedList$: BehaviorSubject<Array<AnimalBreed>> = new BehaviorSubject<Array<AnimalBreed>>(
    []
  );
  apiBaseUrl = environment.apiBaseUrl;
  animalItemObj: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  phasedDairyCattle = ['calves', 'young_heifers', 'heifers', 'dry', 'lactation'];
  phasedBeefCattle = [
    'veal_with_white_meat',
    'bullock',
    'bull',
    'beef',
    'ox',
    'cull_cow',
    'heifer',
  ];
  weaningStatusDropdown = Object.values(WeaningStatus).map((id) => ({ id }));
  lactationCharacterization = Object.values(LactationCharacterization).map((id) => ({ id }));

  constructor() {}

  getAnimaleImages() {
    const images = [];
    this.imgAnimals.forEach((img) => {
      images.push(this.awsbucket + img);
    });
    return images;
  }

  getAnimalsListFromLocalStore(): Observable<Animal[]> {
    return this.animalsList;
  }

  getAnimals(): Observable<Animal[]> {
    return this.http.get<any>(this.apiBaseUrl + 'api/private/v1/animals').pipe(
      map((response) => {
        this.animalsList.next(response);
        return response;
      })
    );
  }

  getAnimal(id: number): Observable<Animal> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/animals/' + id)
      .pipe(map((response) => response));
  }

  getAnimalBreed(): Observable<AnimalBreed> {
    return this.http.get<any>(this.apiBaseUrl + 'api/private/v1/animalBreed').pipe(
      map((response) => {
        this.animalBreedList$.next(response);
        return response;
      })
    );
  }

  saveAnimal(animalItem): Observable<Animal> {
    const animal = { ...animalItem };
    delete animal.lastUpdated;
    delete animal.dateCreated;
    const companySelected = JSON.parse(localStorage.getItem('companySelected'));
    animal.companyId = companySelected ? companySelected.id : null;

    if (animal.id) {
      return this.http
        .put<Animal>(this.apiBaseUrl + 'api/private/v1/animals/' + animal.id, animal)
        .pipe(map((response) => response));
    } else {
      return this.http
        .post<Animal>(this.apiBaseUrl + 'api/private/v1/animals', animal)
        .pipe(map((response) => response));
    }
  }

  sendMovingAnimals(movingAnimal: MovingAnimals): Observable<MovingAnimals> {
    delete movingAnimal.lastUpdated;
    delete movingAnimal.dateCreated;
    delete movingAnimal.id;
    delete movingAnimal.multipleboxes[0].name;
    delete movingAnimal.multipleboxes[0].productionOrientation;
    delete movingAnimal.multipleboxes[0].animalCount;
    const companySelected = JSON.parse(localStorage.getItem('companySelected'));
    movingAnimal.companyId = companySelected ? companySelected.id : null;
    return this.http
      .post<MovingAnimals>(this.apiBaseUrl + 'api/private/v1/animalMovement', movingAnimal)
      .pipe(map((response) => response));
  }

  deleteAnimal(animal: Animal): Observable<Animal> {
    return this.http.delete(this.apiBaseUrl + 'api/private/v1/animals/' + animal.id).pipe(
      map((response) => {
        return { id: animal.id } as Animal;
      })
    );
  }

  getAnimalById = (id: number): Animal => {
    let item: Animal;
    this.animalsList
      .pipe(first((list: Animal[]) => list && list.length > 0))
      .subscribe((list: Animal[]) => {
        item = list.find((i) => i.id === id);
      });
    return item;
  };

  getImagesByBreedList = (breedList: Array<string>): Array<string> => {
    const result = [];
    this.animalBreedList$
      .pipe(first((list: AnimalBreed[]) => list.length > 0))
      .subscribe((list) => {
        if (list && list.length > 0) {
          list.forEach((breed) => {
            if (breedList.includes(breed.name)) {
              result.push(breed.imgUrl);
            }
          });
        }
      });

    return _.uniq(result);
  };

  retrieveProductionOrientationList() {
    return [
      'dairy_cattle',
      'beef_cattle',
      'swine',
      'ovine',
      'caprine',
      'chicken',
      'turkey',
      'laying_hen',
      'equine',
    ];
  }

  retrieveProductionOrientationListwithoutOvine() {
    return ['dairy_cattle', 'beef_cattle', 'swine', 'ovine', 'caprine', 'equine'];
  }

  getAnimalMovements(stableId) {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v2/livestock/animalMovement?stableId=' + stableId)
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
}
